import {
  gamification
} from '../constants';

/**
 * Import constants
 */
const {
  SET_PASSED_RF_QUIZ,
  SET_PASSED_LM_QUIZ,
  SET_PASSED_MM_QUIZ,
  SET_BADGE,
  SET_WHOLE_GAMIFICATION
} = gamification;

/**
 * Action creators
 */
const actions = {
  setPassedRfQuiz: (data) => ({ type: SET_PASSED_RF_QUIZ, data }),
  setPassedLmQuiz: (data) => ({ type: SET_PASSED_LM_QUIZ, data }),
  setPassedMmQuiz: (data) => ({ type: SET_PASSED_MM_QUIZ, data }),
  setBadges: (data) => ({ type: SET_BADGE, data }),
  setWhole: (data) => ({ type: SET_WHOLE_GAMIFICATION, data })
};

/**
 * Set whole gamification data
 */
export const setWhole = (data) => (dispatch) => dispatch(actions.setWhole(data));

/**
 * Set discovery data
 */
export const setPassedRfQuiz = (data) => (dispatch) => dispatch(actions.setPassedRfQuiz(data));

/**
 * Update discovery data
 */
export const setPassedLmQuiz = (data) => (dispatch) => dispatch(actions.setPassedLmQuiz(data));

/**
 * Update discovery data
 */
export const setPassedMmQuiz = (data) => (dispatch) => dispatch(actions.setPassedMmQuiz(data));

/**
 * Set acquired badges
 */
export const setBadges = (data) => (dispatch) => dispatch(actions.setBadges(data));
